module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10268.2cb5656a.jpg";